module.exports = __webpack_public_path__ + "img/good-practice.6321029a.png";